import {Occupancy} from "@variocube/app-api";

export interface Customer {
    phone: string;
    lastName: string;
    firstName: string;
    email: string;
}

export enum OrderState {
    Ordered = "Ordered",
    WaitingForPickupByShop = "WaitingForPickupByShop",
    Processing = "Processing",
    ReadyForDelivery = "ReadyForDelivery",
    WaitingForPickupByCustomer = "WaitingForPickupByCustomer",
    Complete = "Complete",
}

export interface Order {
    id: number;
    orderType: OrderType;
    orderNumber: string;
    orderDate: string;
    customerStoredDate?: string;
    orderState: OrderState;
    customer: Customer;
    readyForDelivery: boolean;
    paymentDate?: string;
    amount?: number;
    allowPickupDate?: string;
    internalNotes?: string;
    foreignId?: string;
    storageCode?: string;
}

export interface Shop {
    id: string;
    name: string;
    logoUrl?: string;
    accessCode: string;
    orders: Order[];
    defaultBoxTypeShop: string;
    shopType: ShopType;
    websiteUrl?: string;
    email?: string;
    phone?: string;
    customersManuallyConfirmPickup?: boolean;
    orderOptions: {
        email?: string;
        phone?: string;
        app?: string;
        url?: string;
    }
    offer: {
        shortDescription?: string;
        longDescription?: string;
    }
}

export enum ShopType {
    DryCleaning = "DryCleaning",
    Goods = "Goods",
    Services = "Services",
}

export interface Shops {
    [key: string]: Shop;
}

export interface Marketplace {
    id: string;
    title: string;
    logoUrl: string;
}

export enum OrderOccupancyType {
    Inbound = "Inbound",
    Outbound = "Outbound"
}

export enum OrderType {
    Inbound = "Inbound",
    Outbound = "Outbound",
    Service = "Service"
}

export interface OrderOccupancyContent {
    order: Order;
    type: OrderOccupancyType;
}

export interface ShopHomeViewProps {
    shop: Shop;
    onBack?: () => void;
}

export enum AppMode {
    DryCleaning,
    Marketplace
}

export interface CubeOrder {
    order: Order;
    occupancy?: Occupancy;
}

export function getOccupancyOrder(occupancy: Occupancy) {
    const {order} = occupancy.content;
    if (order?.id && order?.orderType) {
        return order as Order;
    }
}